// src/constants/gamePresets.ts

export interface GamePreset {
  id: string;
  name: string;
  rows: number;
  cols: number;
  setup: string;
}

export const GAME_PRESETS: GamePreset[] = [
  {
    id: "0808-001",
    name: "Traditional FIDE Chess (8x8)",
    rows: 8,
    cols: 8,
    setup: "traditional",
  },
  {
    id: "0909-001",
    name: "Perfect Chess (9x9)",
    rows: 9,
    cols: 9,
    setup: "perfect",
  },
  {
    id: "1010-001",
    name: "Breakout Chess (10x10)",
    rows: 10,
    cols: 10,
    setup: "breakout",
  },
  {
    id: "1111-001",
    name: "Next Level Chess (11x11)",
    rows: 11,
    cols: 11,
    setup: "nextlevel",
  },
  {
    id: "1212-001",
    name: "Arrival Chess (12x12)",
    rows: 12,
    cols: 12,
    setup: "arrival",
  },
  {
    id: "empty",
    name: "Empty Board",
    rows: 8,
    cols: 8,
    setup: "empty",
  },
];

/**
 * Get a preset by ID
 */
export const getPresetById = (id: string): GamePreset | undefined => {
  return GAME_PRESETS.find((preset) => preset.id === id);
};

/**
 * Get all standard presets (excluding empty board)
 */
export const getStandardPresets = (): GamePreset[] => {
  return GAME_PRESETS.filter((preset) => preset.id !== "empty");
};

/**
 * Get preset by board size
 */
export const getPresetBySize = (rows: number, cols: number): GamePreset | undefined => {
  return GAME_PRESETS.find((preset) => preset.rows === rows && preset.cols === cols);
};
